// extracted by mini-css-extract-plugin
export var aircallIframe = "_n5-3";
export var fabContainer = "_n5-5";
export var fabRinging = "_n5-6";
export var loadingOverlay = "_n5-4";
export var pulse = "_n5-7";
export var widgetContent = "_n5-2";
export var widgetPanel = "_n5-0";
export var widgetPanelExpanded = "_n5-1";